/*
  Bons plans — nav d'onglets par categorie.

  CE QUE FAIT CE FICHIER, ET RIEN D'AUTRE : intercepter le clic sur un onglet, aller
  chercher la grille correspondante, et la substituer. L'impression GA4 du bloc reste
  dans assets/bons-plans.js, qui a sa propre responsabilite.

  SOURCE DES VELOS. Chaque onglet est un vrai lien vers la collection filtree par le
  filtre natif de la boutique (`filter.p.m.velo.categorie_secondaire`). On demande la
  meme URL avec `&section_id=`, ce qui rend la section entiere dans le contexte de cette
  collection filtree, et on n'en garde que la grille. Sans JS, le lien navigue : le
  visiteur voit la meme selection sur la page de collection, ce qui est une degradation
  acceptable et non une panne.

  ⚠️ PIEGE DE CADRAGE (anti-pattern n°44). Une section servie par `?section_id=` recoit
  les `default` de son schema, JAMAIS les reglages du marchand : la reponse peut donc
  contenir un nombre de cartes different de celui que le marchand a regle. On recadre
  cote client, en lisant `data-bp-limit` sur la grille DEJA presente dans la page —
  celle-la, et elle seule, a ete rendue avec les vrais reglages.

  Le premier onglet ne declenche aucun fetch : sa grille est celle du rendu serveur, on
  la garde en memoire des l'init et on la restaure telle quelle.
*/
(function () {
  'use strict';

  var CACHE = new WeakMap();

  function tabs(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-bp-tab]'));
  }

  function setActive(root, tab) {
    tabs(root).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      if (on) {
        t.setAttribute('aria-current', 'true');
      } else {
        t.removeAttribute('aria-current');
      }
    });
  }

  function gridOf(root) {
    return root.querySelector('[data-bp-grid]');
  }

  // Le lien « Voir la collection » suit l'onglet actif : chaque onglet porte sa cible en
  // `data-bp-cta` (collection dediee si le marchand en a choisi une, sinon la collection
  // bons plans filtree sur sa categorie). Le serveur a rendu celle du premier onglet,
  // donc sans JavaScript le lien reste juste — comme les onglets, qui naviguent alors.
  function syncCta(root, tab) {
    var link = root.querySelector('[data-bp-cta-target]');
    if (!link) return;
    var href = tab.getAttribute('data-bp-cta');
    if (href) link.setAttribute('href', href);
  }

  // Recadre au nombre de cartes que le marchand a regle, que la reponse en contienne
  // plus ou moins (cf. le piege de cadrage en tete de fichier).
  function trim(grid, limit) {
    if (!limit || limit < 1) return;
    var cards = grid.children;
    while (cards.length > limit) grid.removeChild(cards[cards.length - 1]);
  }

  function apply(root, html, limit) {
    var grid = gridOf(root);
    if (!grid) return;
    grid.innerHTML = html;
    trim(grid, limit);
    grid.removeAttribute('aria-busy');
    // Le bloc d'impression GA4 doit pouvoir recompter : on le previent que le contenu
    // a change, plutot que de dupliquer sa logique ici.
    root.dispatchEvent(new CustomEvent('bons-plans:grid-changed', { bubbles: true }));
  }

  function load(root, tab) {
    var grid = gridOf(root);
    if (!grid) return;
    var limit = parseInt(grid.getAttribute('data-bp-limit'), 10) || 0;
    var cat = tab.getAttribute('data-bp-category') || '';

    var store = CACHE.get(root) || {};
    if (Object.prototype.hasOwnProperty.call(store, cat)) {
      apply(root, store[cat], limit);
      return;
    }

    var url = tab.getAttribute('href');
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    grid.setAttribute('aria-busy', 'true');
    grid.classList.add('is-loading');

    fetch(url + sep + 'section_id=bons-plans', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-bp-grid]');
        // Une categorie sans aucun velo disponible rend une grille VIDE, pas une erreur :
        // on l'affiche telle quelle plutot que de laisser l'onglet precedent en place,
        // ce qui ferait croire que le clic n'a pas ete pris.
        var markup = fresh ? fresh.innerHTML : '';
        store[cat] = markup;
        CACHE.set(root, store);
        apply(root, markup, limit);
      })
      .catch(function () {
        // On ne laisse PAS une grille vide sans explication : le lien reste valide, donc
        // on rend la main au visiteur en le laissant naviguer.
        grid.removeAttribute('aria-busy');
        window.location.href = tab.getAttribute('href');
      })
      .then(function () {
        grid.classList.remove('is-loading');
      });
  }

  function bind(root) {
    if (root.dataset.bpTabsBound === '1') return;
    if (!root.querySelector('[data-bp-tabs]')) return;
    root.dataset.bpTabsBound = '1';

    // La grille du rendu serveur est celle du PREMIER onglet : on la memorise avant tout
    // remplacement, sinon un retour sur cet onglet couterait un fetch inutile — et
    // surtout, il ne rendrait PAS la meme chose (la reponse de `?section_id=` ignore les
    // reglages du marchand, dont la collection choisie).
    var grid = gridOf(root);
    var first = tabs(root)[0];
    if (grid && first) {
      var store = {};
      store[first.getAttribute('data-bp-category') || ''] = grid.innerHTML;
      CACHE.set(root, store);
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-bp-tab]');
      if (!tab || !root.contains(tab)) return;
      // Clic modifie (nouvel onglet, nouvelle fenetre) : on laisse le navigateur faire.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      if (tab.classList.contains('is-active')) return;
      setActive(root, tab);
      syncCta(root, tab);
      load(root, tab);
    });
  }

  function init(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-bons-plans]'), bind);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
